import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'space-between',
    cursor: 'pointer',
    width: '100%',

    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },

  usernameContainer: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    width: '100%',
  },

  username: {
    textTransform: 'capitalize',
    maxWidth: '60%',
  },

  text: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    lineHeight: 'inherit',
  },

  arrowIcon: {
    fontSize: theme.spacing(2),
  },
}));
